import React from 'react';
import OdiseaCarousel from '../carousel/carousel';

export default class ArticleTwo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <article id={this.props.id} className='content-article article-two'>
                <OdiseaCarousel />
            </article>
        );
    }
}